import React, { useState, useEffect } from "react";
import { MDBContainer } from "mdb-react-ui-kit";
import { Avatar, message } from "antd";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { SendGetRequest } from "./ApiRequest";
import axios from "axios";
import { useDispatch } from "react-redux";
import { setDashboardData } from "../Store/Slices/countrySlice";

const Login = (props) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [yearError, setYearError] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [selectedYear, setSelectedYear] = useState(4);
  const [loading, setLoading] = useState(false);
  const selectedDevice = "mobile";
  const dispatch = useDispatch();

   function alreadyLoggedIn() {
    const savedData = localStorage.getItem("token");
    const rememberME = localStorage.getItem("RememberMe");

    if (savedData && rememberME === "true") {
      navigate("/dashboard");
    } else {
      navigate("/login");
    }
  }
  useEffect(() => {

    alreadyLoggedIn();
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (email === "") {
      setEmailError("Please enter your email");
    } else {
      setEmailError("");
    }

    if (password === "") {
      setPasswordError("Please enter your password");
    } else {
      setPasswordError("");
    }

    if (!selectedYear) {
      setYearError("Select Year");
    } else {
      setYearError("");
    }
    if (
      email !== "" &&
      password !== "" &&
      selectedYear !== null &&
      selectedDevice !== ""
    ) {
      try {
        setLoading(true);
        const requestBody = {
          email,
          password,
          year: selectedYear,
          device: selectedDevice,
        };


const baseUrl = `https://api.${props.apiHost}/guest/login`;
const finalUrl = baseUrl + window.getLocalApiQuery(baseUrl);

    
        const response = await axios.post(
          finalUrl,
          requestBody
        );
        if (response.data.status === "success") {
          const token = response.data.token;

          localStorage.setItem("token", token);
          
          localStorage.setItem("RememberMe", true);

          dispatch(setDashboardData(response.data.data));
          setLoading(false);

          message.success("Login successful");
          navigate("/dashboard", {
            state: { responseData: response.data.data },
          });
        } else if (response.data.status === "fail") {
          message.error(response.data.message);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);

        // console.error("Error logging in:", error);
        message.error("Error logging in. Please try again.");
      }
    }
  };

  const [years, setYears] = useState([]);

  useEffect(() => {
    handleInputClick();
  }, []);

  // for www domain this api give problem
  const handleInputClick = async () => {
    try {
      const endpoint = "guest/calendar";
      const response = await SendGetRequest(endpoint);

      // console.log(response);

      if (response.status === "success") {
        setYears(response.data);
      }
      return;
    } catch (error) {
      console.error(error);
    }
  };


  return (
    <>
      <style>
        {`
          .custom-placeholder::placeholder {
            color: #FFFFFF; 
            
            
          }
        `}
      </style>
      <div className="overflow-hidden">
        <div className="background-image-LogIn-logo">
          <MDBContainer breakpoint="sm m-4">
            <div className="main-wrapper">
              <div>
                <div
                  className="navebar"
                  style={{
                    background: "",
                    width: "100%",
                    marginBottom: "20px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <img
                    className="logo mb-3"
                    src={window.logo}
                    alt="logo"
                    style={{ width: "200px" }}
                  />
                </div>

{/* second  */}
                <div className="login-form-wrapper">
                  <form>
                    <div className={`row furas-Login-inputs px-2 `}>
                      <input
                        type="email"
                        className={
                          "form-control my-login-input  custom-placeholder bg-dark text-light   " +
                          (emailError !== "" ? "highlight" : "")
                        }
                        id="exampleInputEmail1"
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="E-Mail ID"
                        aria-describedby="emailHelp"
                        required
                      />
                      {emailError !== "" && (
                        <p className="error-message red-color">{emailError}</p>
                      )}
                    </div>
                    <div className={`row furas-Login-inputs px-2`}>
                      <input
                        type="password"
                        className={
                          "form-control mb-2 custom-placeholder bg-dark text-light " +
                          (passwordError !== "" ? "highlight" : "")
                        }
                        id="exampleInputPassword1"
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Password"
                        required
                      />
                      {passwordError !== "" && (
                        <p className="error-message red-color">
                          {passwordError}
                        </p>
                      )}
                    </div>
                    {/* 
                  <div
                    className={`row furas-Login-inputs px-2`}
                    style={{ paddingTop: "20px" }}>
                    <select
                      // onClick={handleInputClick}
                      style={{ backgroundColor: "#979797" }}
                      className={
                        `form-control mb-2 my-login-calendar custom-placeholder  bg-dark text-light opacity-50
                        ${
                          yearError !=="" ? "highlight" : ""
                        }
                          
                        
                        
                        ` 
                        
                      }
                      id="Year"
                    
                      name="Year"
                      data-prompt-position="bottomLeft:20,35"
                      onChange={(e) => setSelectedYear(e.target.value)}
                      value={selectedYear}
                      required>
                      <option value="0" disabled selected>
                        Select Year
                      </option>
                      {years.map((year) => (
                        <option key={year.UID} value={year.UID}>
                          {year.Title}
                        </option>
                      ))}
                    </select>
                    {
                      yearError ? 
                      <p className="error-message red-color">please select year</p> :""
                    }
                  </div> */}
                    <div className="form-check pt-4 pb-4  ">
                      <input
                        className="form-check-input my-login-check-remember"
                        type="checkbox"
                        value=""
                        onChange={(e) => {
                          setRememberMe(!rememberMe);
                        }}
                        id="flexCheckDefault"
                      />{" "}
                      &nbsp;
                      <label
                        className="form-check-label my-login-remember"
                        htmlFor="flexCheckDefault"
                      >
                        Remember me
                      </label>
                    </div>
                    <button
                      type="submit"
                      className={`Login-btn my-login-btn-text`}
                      style={{ margin: "0px" }}
                      onClick={handleLogin}
                    >
                      {loading ? <span>Loading</span> : <span>Log In</span>}
                    </button>
                    <div
                      className="login-forget my-login-forget pt-4 "
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <Link to="/reset-password" className="my-login-forget ">
                        Forgot Password?
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </MDBContainer>
        </div>
      </div>
    </>
  );
};

export default Login;
